module.exports = __webpack_public_path__ + "img/06.c192f565.png";